import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import { toast } from 'react-toastify';

import SpinnerBlock from '../../../common/SpinnerBlock';

import { showModal } from '../../../../actions/modal';
import { fetchGetWorksheet, fetchUpdateWorksheet } from '../../../../actions/orders';

import { checkOrderConfirmation, parseError } from '../../../../helpers';
import Toogle from '../../../common/Toogle';
import Checkbox from './../../../common/Checkbox';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  position: relative;
  padding-left: 0;
  padding-right: 0;

  > div {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-bottom: 24px;
    &:last-child {
      padding-bottom: 0;
    }
  }
  .block-subtitle {
    margin-bottom: 8px;
  }

  .card-title {
    padding-top: 4px;
    padding-bottom: 23px;
    align-items: center;
    h4 {
      font-size: 16px;
      margin: 0;
    }
  }

  .file-type-toggle {
    margin: -15px 0 20px 0;
  }
`;

const FieldWrapper = styled('div')`
  .file-type-toggle {
    margin: -10px 0 20px;
  }

  .dropzone {
    display: flex;
    align-items: center;
    padding: 5px;
    min-height: 100px;
    cursor: pointer;
    background-color: #ffffff;
    border: 2px dashed rgba(50, 58, 70, 0.3);

    &.with-text {
      width: 100%;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
      transition-duration: 0.3s;
    }
  }

  .selected-file {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5px;
    min-height: 100px;
    background-color: #f1f5f7;
    border-radius: 0.2rem;
    position: relative;

    .selected-file-name {
      text-decoration: underline;
    }

    .selected-file-close {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 1.4rem;
      padding: 5px 10px;
      font-weight: 700;
      line-height: 1;
      color: #000;
      opacity: 0.5;
      cursor: pointer;

      :hover {
        opacity: 1;
      }
    }

    .file-type-toggle {
      margin: -15px 0 20px 0;
    }
  }
`;

const Field = (props) => {
  const { id, value, formData, inputType, t } = props;

  const currentField = formData && formData.find((f) => f.id === id);
  const currentValue = currentField ? currentField.value : value;
  const currentTitle = currentField ? currentField.title : value;

  const FieldValueComponent = () => {
    if (currentField?.id === 'require_individual_additional_packing') {
      return (
        <Checkbox
          label={t('Индивидуальная доп. упаковка товара')}
          checked={currentField?.value}
          disabled
        />
      );
    } else if (currentField?.id === 'use_factory_master_boxes') {
      return (
        <Checkbox
          checked={currentField?.value}
          label={t('Использовать заводские мастер-короба')}
          disabled
        />
      );
    } else if (currentField?.id === 'shipment_box_multiplicity_use_in_packing') {
      return (
        <Checkbox
          checked={currentField?.value}
          label={t('Корректировать число упаковочных коробов под указанную кратность')}
          disabled
        />
      );
    } else if (inputType === 'MULTI') {
      return (
        <div>
          {currentTitle ? currentTitle : <i>{currentValue || t('Данные не заполнены')} </i>}
        </div>
      );
    } else {
      return <div>{currentValue ? currentValue : <i>{t('Данные не заполнены')}</i>}</div>;
    }
  };

  return (
    <FieldWrapper>
      <div key={id} className="fbo-item">
        <div className="block-subtitle">{t(props.name)}</div>
        <FieldValueComponent />
      </div>
    </FieldWrapper>
  );
};

const WorksheetBlock = (props) => {
  const { isNew, currentOrder, fields, actualizeOrder } = props;

  const dispatch = useDispatch();

  const [formData, setFormData] = useState(null);

  const [loading, setLoading] = useState(false);

  const { t } = useAutoTranslation();

  useEffect(() => {
    if (!isNew && typeof currentOrder.id !== 'undefined') {
      (async function () {
        setLoading(true);

        const result = await dispatch(fetchGetWorksheet(currentOrder.id));

        setFormData(result);

        setLoading(false);
      })();
    }
  }, [currentOrder]);

  const handleFboFormModal = () => {
    dispatch(
      showModal('EditWorksheetModal', {
        fields,
        formData,
        currentOrder,
        actualizeOrder,
        handleSave: async (values) => {
          await dispatch(
            fetchUpdateWorksheet({
              orderId: currentOrder.id,
              form_content: fields.map((f) => ({
                ...f,
                value: values[f.id],
              })),
            }),
          )
            .then((newData) => {
              setFormData(newData);
              toast.info(t('Анкета отправки успешно обновлена'));
            })
            .catch((err) => {
              toast.error(parseError(err));
            });
        },
      }),
    );
  };

  return (
    <Wrapper className="card-box">
      <SpinnerBlock show={loading} />

      <div style={{ display: 'flex' }} className="card-title">
        <h4 className="header-title">{t('Анкета отгрузки')}</h4>
        <div className="change-link" style={{ marginLeft: 'auto' }} onClick={handleFboFormModal}>
          {t('Изменить')}
        </div>
      </div>

      <div className="border-top pb-1" />
      {fields ? (
        <>
          {fields.map((f) => (
            <Field key={f.id} {...f} formData={formData} currentOrder={currentOrder} t={t} />
          ))}
        </>
      ) : null}
    </Wrapper>
  );
};

export default WorksheetBlock;
